// import api from './axiosInstance';

// export const delegationsService = {
//   getAll: async () => {
//     const response = await api.get('/suplencias');
//     return response.data;
//   },

//   create: async (data) => {
//     const response = await api.post('/suplencias', data);
//     return response.data;
//   },

//   update: async (id, data) => {
//     const response = await api.put(`/suplencias/${id}`, { request: data });
//     return response.data;
//   },
// };

import api from './axiosInstance';

export const delegationsService = {
  getPaged: async (params = {}) => {
    const response = await api.get('/suplenciasv2', { params });
    return response.data;
  },

  getCatalogs: async () => {
    const response = await api.get('/suplenciasv2/catalogs');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/suplenciasv2/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/suplenciasv2', data );
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/suplenciasv2/${id}`, data );
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/suplenciasv2/${id}`);
    return response.data;
  },

  checkPermanent: async (userId) => {
    const response = await api.get('/suplenciasv2/check-permanent', { params: { userId } });
    return response.data;
  },

  finalize: async (id) => {
    const response = await api.post(`/suplenciasv2/${id}/finalize`);
    return response.data;
  },
};



